import { useEffect, useState } from "react";
import { analyticsConfigured, getConsent, loadTrackers, setConsent } from "../../lib/analytics";

export function ConsentBanner() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!analyticsConfigured()) return;
    const c = getConsent();
    if (c === "granted") loadTrackers();
    else if (!c) setOpen(true);
  }, []);
  if (!open) return null;
  const choose = (v) => { setConsent(v); setOpen(false); };
  return (
    <div role="dialog" aria-label="Analytics consent" data-testid="consent-banner"
      className="fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-xl rounded-2xl glass bg-ink/90 p-5 text-sm text-slate-300 sm:bottom-6">
      <p>We'd like to use analytics and advertising cookies (Google Analytics, Meta Pixel) to measure how our site and ads perform. They only load if you allow them. See our <a className="underline" href="/privacy-policy">Privacy Policy</a>.</p>
      <div className="mt-4 flex gap-3">
        <button data-testid="consent-accept-btn" className="btn-primary !py-2.5" onClick={() => choose("granted")}>Allow</button>
        <button data-testid="consent-decline-btn" className="btn-ghost !py-2.5" onClick={() => choose("denied")}>Decline</button>
      </div>
    </div>
  );
}
